import React from 'react';
import { BookOpenIcon } from 'lucide-react';
import { UrgencyBar } from './UrgencyBar';
export const Header = () => {
  return <header className="bg-black text-bttf-text border-b border-bttf-accent/30 z-50 sticky top-0" data-id="element-219">
      <div className="container mx-auto px-4 py-4 flex justify-between items-center" data-id="element-220">
        <div className="flex items-center space-x-2" data-id="element-221">
          <span className="font-bold text-lg bg-gradient-main text-transparent bg-clip-text" data-id="element-222">
            Back In Time
          </span>
        </div>
        <nav data-id="element-223">
          <ul className="flex space-x-3 md:space-x-6 items-center" data-id="element-224">
            <li className="hidden md:block" data-id="element-225"></li>
            <li className="hidden md:block" data-id="element-226"></li>
            <li data-id="element-227">
              <a href="#pricing-top" className="bg-bttf-primary hover:bg-bttf-primary-hover text-bttf-text font-bold px-3 py-2 sm:px-4 sm:py-2 rounded-md transition-colors shadow-md hover:shadow-neon-orange text-sm sm:text-base whitespace-nowrap" data-id="element-228">
                Get My Copy
              </a>
            </li>
          </ul>
        </nav>
      </div>
      <UrgencyBar data-id="element-229" />
    </header>;
};